import { render, staticRenderFns } from "./AssociateWineFilters.vue?vue&type=template&id=b2c50432&scoped=true"
import script from "./AssociateWineFilters.vue?vue&type=script&lang=js"
export * from "./AssociateWineFilters.vue?vue&type=script&lang=js"
import style0 from "./AssociateWineFilters.vue?vue&type=style&index=0&id=b2c50432&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c50432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2c50432')) {
      api.createRecord('b2c50432', component.options)
    } else {
      api.reload('b2c50432', component.options)
    }
    module.hot.accept("./AssociateWineFilters.vue?vue&type=template&id=b2c50432&scoped=true", function () {
      api.rerender('b2c50432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/AssociateWine/AssociateWineFilters.vue"
export default component.exports